import { useEffect, useState } from "react";
import PacmanLoader from "react-spinners/PacmanLoader";

const LoadingPacman: React.FC<{ loading?: boolean }> = ({ loading = true }) => {
    const [LoadingColor, setLoadingColor] = useState("");

    useEffect(() => {
        setLoadingColor(getComputedStyle(document.body).getPropertyValue("--kt-primary"));
    }, []);

    return (
        <>
            {loading && (
                <div className="rounded loadingPacmanWrapper" style={{}}>
                    <PacmanLoader loading={loading} color={LoadingColor} />
                </div>
            )}
        </>
    );
};

export default LoadingPacman;
